export function showLoadingState(): void {
  showLoadingTemplate()
  showLoadingReconciliationIcon()
  toggleActionsButton()
}

function showLoadingTemplate(): void {
  const liveInputsSelector = document.querySelector(
    '[data-behaviour="live-inputs"]'
  ) as HTMLElement
  const loadingStateSelector = document.querySelector(
    '#reconciliation-loading-state'
  ) as HTMLElement

  window.requestAnimationFrame(() => {
    if (liveInputsSelector) liveInputsSelector.innerHTML = ''
    if (loadingStateSelector) loadingStateSelector.classList.toggle('hidden')
  })
}

function showLoadingReconciliationIcon(): void {
  const reconcilationIcon = document.querySelector(
    '[data-behaviour="reconciliation-summary"]'
  ) as HTMLElement

  if (reconcilationIcon) {
    const loadingIconWrapper = document.createElement('div') as HTMLElement

    window.requestAnimationFrame(() => {
      reconcilationIcon.innerHTML = ''
      loadingIconWrapper.classList.add(
        'sf-level-item',
        'sf-spinner',
        'sf-spinner-primary',
        'tw-m-auto'
      )
      reconcilationIcon.append(loadingIconWrapper)
    })
  }
}

function toggleActionsButton(): void {
  const reconciliationActions = document.querySelector(
    '#reconciliation-actions'
  ) as HTMLElement
  const reconciliationActionsDisabled = document.querySelector(
    '#reconciliation-actions-disabled'
  ) as HTMLElement

  window.requestAnimationFrame(() => {
    if (reconciliationActions)
      reconciliationActions.classList.toggle('tw-hidden')
    if (reconciliationActionsDisabled)
      reconciliationActionsDisabled.classList.toggle('tw-hidden')
  })
}
